export default __webpack_public_path__ + "images/1edb369711abf43026eb78448f76b78a.png";